import { render, staticRenderFns } from "./DifferentiatingBenefitsBrazilianitySection.vue?vue&type=template&id=7e4ed3e5"
import script from "./DifferentiatingBenefitsBrazilianitySection.vue?vue&type=script&lang=ts"
export * from "./DifferentiatingBenefitsBrazilianitySection.vue?vue&type=script&lang=ts"
import style0 from "./DifferentiatingBenefitsBrazilianitySection.vue?vue&type=style&index=0&id=7e4ed3e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports